<script lang="ts">
  import Loading from '$lib/components/Loading.svelte';
  import LogInSplash from '$lib/components/LogInSplash.svelte';
  import { auth } from '$lib/stores/auth.svelte';
  import { userRoleRedirect } from '$lib/util';

  $effect(() => {
    if (!auth.loading) {
      userRoleRedirect();
    }
  });
</script>

{#if !auth.user && auth.loading}
  <main id="main-content" class="container py-3">
    <Loading />
  </main>
{:else}
  <LogInSplash />
{/if}
